const routesName = {
  dashboard: "dashboard",
  login: "login",
  confirmAccount: "confirmAccount",
  courses: "courses",
  courseCreate: "courseCreate",
  moduleCreate: "moduleCreate",
  partCreate: "partCreate",
  courseEdit: "courseEdit",
  moduleEdit: "moduleEdit",
  partEdit: "partEdit",
  learningCenters: "learningCenters",
  learningCenterCreate: "learningCenterCreate",
  learningCenterEdit: "learningCenterEdit",
  users: "users",
  managers: "managers",
  managerCreate: "managerCreate",
  singleUser: "singleUser",
  blog: "blog",
  trendingSpecialties: "trendingSpecialties",
  settings: "settings",
  specialtyCreate: "specialtyCreate",
  specialtyEdit: "specialtyEdit",
  creditCreate: "creditCreate",
  creditEdit: "creditEdit",
  notFound: "notFound",
};

export default routesName;
